export const SOCIAL = {
  linkedin: "https://www.linkedin.com/in/jasonwkuo/",
  github: "https://github.com/jkuo630",
  email: "mailto:jasonkuo630@gmail.com",
};

export function openExternal(url) {
  window.open(url, "_blank", "noreferrer,noopener");
}
